import { useAppDispatch } from 'app/hooks';
import {
  useAssignImageToStructureItemMutation,
  useUpdateStructureImageTransformMutation
} from 'features/api/project-api';
import { useCallback } from 'react';
import { assignLevelLayoutImage } from 'utils/assign-level-layout-image';

export function useAssignLevelLayoutImage() {
  const dispatch = useAppDispatch();
  const [assignImage] = useAssignImageToStructureItemMutation();
  const [updateTransform] = useUpdateStructureImageTransformMutation();

  return useCallback(
    (attachmentId: number, structureItemUniqueId: string) =>
      assignLevelLayoutImage({
        dispatch,
        attachmentId,
        structureItemUniqueId,
        assignImage,
        updateTransform
      }),
    [dispatch, assignImage, updateTransform]
  );
}
